import { FormHelperText, Grid, TextField } from '@mui/material'
import TinyRichEditor from '../../../../../shared/components/TinyRichEditor'
import { InputCountry } from '../../../../../shared/components/inputs'
import RoleAutocomplete from '@/contexts/shared/components/inputs/RoleAutocomplete'
import StatusAutocomplete from '@/contexts/shared/components/inputs/StatusAutocomplete'
import VisibilityAutocomplete from '@/contexts/shared/components/inputs/VisibilityAutocomplete'
import { IRootState } from '@/redux/types'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { IStatus, IVisibility } from '@/contexts/backoffice/courses/models/course'
import LanguageMultiAutocomplete from '@/contexts/shared/components/inputs/LanguageMultiAutocomplete'

interface NewsGeneralTabContentProps {
  newState: any
  handleInputChange: (inputName: string, value: any) => void
  VISIBILITY: IVisibility[]
  STATUS: IStatus[]
}

export const NewsGeneralTabContent = ({ newState, handleInputChange, VISIBILITY, STATUS }: NewsGeneralTabContentProps) => {
  const { t } = useTranslation(['global'])

  const { msgForm, errorForm } = useSelector((state: IRootState) => state.validator)

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={4}>
        <InputCountry value={newState.countries} handleInputChange={handleInputChange} />
      </Grid>
      <Grid item xs={12} sm={4}>
        <LanguageMultiAutocomplete value={newState.languages} handleInputChange={handleInputChange} />
      </Grid>
      <Grid item xs={12} sm={4}>
        <RoleAutocomplete value={newState.role} handleInputChange={handleInputChange} />
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <StatusAutocomplete value={newState.status} handleInputChange={handleInputChange} options={STATUS} />
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <VisibilityAutocomplete value={newState.visibility} handleInputChange={handleInputChange} options={VISIBILITY} />
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <TextField label={t('author')} fullWidth disabled variant="filled" margin="normal" value={newState.creator} onChange={() => {}} />
      </Grid>
      <Grid item xs={12}>
        <TinyRichEditor handleInputChange={handleInputChange} value={newState.content || ''} uploadURL="/novelties/upload" />
        <FormHelperText error={errorForm.content}>{msgForm.content}</FormHelperText>
      </Grid>
    </Grid>
  )
}
